import React, { memo } from 'react';

import { Button } from '@mui/material';
import { DocumentIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { TaskInfoTestIds } from '../../TaskInfo.testIds';

const documentButtonClasses = {
  root: 'break-all',
};

const OpenDocumentButton = ({ applicationId, loanId, id, fileName, onOpenDocument }) => (
  <Button
    className="mb-24"
    classes={documentButtonClasses}
    color="primary"
    data-application-id={applicationId}
    data-document-id={id}
    data-file-name={fileName}
    data-loan-id={loanId}
    data-testid={TaskInfoTestIds.getOpenDocumentButtonId(id)}
    startIcon={<DocumentIcon />}
    variant="contained"
    onClick={onOpenDocument}
  >
    {fileName}
  </Button>
);

OpenDocumentButton.propTypes = {
  id: PropTypes.string.isRequired,
  onOpenDocument: PropTypes.func.isRequired,
  applicationId: PropTypes.string,
  fileName: PropTypes.string,
  loanId: PropTypes.string,
};

export default memo(OpenDocumentButton);
